// @ts-nocheck
import { createSelector } from 'reselect';

export const getUserStore = store => store.user;

export const getCurrentUser = createSelector([getUserStore], moduleStore => moduleStore.currentUser);

export const getCurrentUserEmail = createSelector([getUserStore], moduleStore => moduleStore.currentUser.email);

export const getShowMasqueradeModal = createSelector([getUserStore], moduleStore => moduleStore.showMasqueradeModal);

export const getShowMasqueradeViewModal = createSelector(
  [getUserStore],
  moduleStore => moduleStore.showMasqueradeModalView
);

export const getIsAdopsUser = createSelector([getCurrentUser], currentUser => {
  return currentUser.userRole.toLowerCase() === 'adops';
});

export const getCanAvoidDataFees = createSelector([getCurrentUser], currentUser => {
  return currentUser.billing.method !== 'prepaid';
});

export const getCountry = createSelector([getCurrentUser], currentUser => currentUser.country);

export const getUserId = createSelector([getCurrentUser], currentUser => currentUser.id);

export const getAttributionProvidersSettings = createSelector(
  [getCurrentUser],
  currentUser => currentUser.attributionSettings
);
